import black_speed_breaker from "../../assets/Products/black_speed_breaker.webp";
import core_cable_protector from "../../assets/Products/2_core_cable_protector.webp";

import df_2 from "../../assets/Products/DFender/2by2.webp";
import df_3 from "../../assets/Products/DFender/3by3.webp";
import df_4 from "../../assets/Products/DFender/4by4.webp";

import d_b_13x10x4 from "../../assets/Products/Bumpers/13x10x4.webp";
import d_b_18x10x4 from "../../assets/Products/Bumpers/18x10x4.webp";
import d_b_18x10x4_2 from "../../assets/Products/Bumpers/18x10x4_2.webp";
import d_b_30x10x4 from "../../assets/Products/Bumpers/30x10x4.webp";
import d_b_30x10x4_2 from "../../assets/Products/Bumpers/30x10x4_2.webp";

import wc_8 from "../../assets/Products/WChockers/wheel_choker_8.webp";
import ac_yellow from "../../assets/Products/WChockers/aircraft_yellow.webp";
import ac_black from "../../assets/Products/WChockers/aircraft_black.webp";
import handle_wc from "../../assets/Products/WChockers/handlewc.webp";
import handle_wc2 from "../../assets/Products/WChockers/handlewc2.webp";
import kirb from "../../assets/Products/WChockers/kirb.webp";
import kirb2 from "../../assets/Products/WChockers/kirb_2.webp";
import car from "../../assets/Products/WChockers/car.webp";
import car2 from "../../assets/Products/WChockers/car2.webp";
import car_yellow from "../../assets/Products/WChockers/car_yellow.webp";
import car_yellow2 from "../../assets/Products/WChockers/car_yellow2.webp";
import lorry from "../../assets/Products/WChockers/lorry.webp";
import lorry2 from "../../assets/Products/WChockers/lorry2.webp";
import yellow_mwc from "../../assets/Products/WChockers/yellow_mwc_1.webp";
import yellow_mwc2 from "../../assets/Products/WChockers/yellow_mwc_2.webp";

import sb_black from "../../assets/Products/Sbraker/black.webp";
import sb_yellow from "../../assets/Products/Sbraker/yellow.webp";
import sb_yellow2 from "../../assets/Products/Sbraker/yellow_2.webp";

import Hcr_4 from "../../assets/Products/HCR_4.webp";
import hc_3 from "../../assets/Products/Hose/3.webp";
import hc_3_2 from "../../assets/Products/Hose/3_2.webp";
import hc_4 from "../../assets/Products/Hose/4.webp";
import hc_4_2 from "../../assets/Products/Hose/4_2.webp";
import hc_5 from "../../assets/Products/Hose/5.webp";
import hc_5_2 from "../../assets/Products/Hose/5_2.webp";

import cp_2 from "../../assets/Products/CableP/2_core.webp";
import cp_1 from "../../assets/Products/CableP/single_core.webp";

import tipper from "../../assets/Products/tipper/tipper_pads.webp";

import Rb_All from "../../assets/Products/RB/RB_ALL.webp";
import Rb8 from "../../assets/Products/RB/Rb8.webp";
import door_bush from "../../assets/Products/RB/door_bush.webp";
import door_bush2 from "../../assets/Products/RB/door_bush2.webp";

import wg from '../../assets/Products/WallGuards/wg1.webp'
import wg2 from '../../assets/Products/WallGuards/wg2.webp'

export const Products = [
  {url:"dock-fenders",
    id: 1,
    title: "Dock Fenders",
    name:"DockFenders",
    description:
      "Innovating Dock Fenders and a comprehensive line of Rubber Products, ensuring superior protection for marine infrastructure worldwide.",
    image: df_2,
    application: [
      "Our fenders serve as a dependable buffer, absorbing impact and minimizing damage during berthing and mooring operations.",
      "With their adaptable design, they cater to a variety of vessel types and docking configurations, ensuring versatile and effective use.",
      "By choosing our rubber fenders, clients invest in long-term safety and operational efficiency, reducing maintenance costs and downtime.",
    ],
    technicals: [
      "NR / SBR Blend",
      "Black",
      "78 + _3 Shore A",
      "8 MPa",
      "5 - 35 Tonnes",
    ],
    variety: [
      { name: "DF 2x2 Inch D", image: [df_2] },
      { name: "DF 3x3 Inch D", image: [df_3] },
      { name: "DF 4x4 Inch D", image: [df_4] },
      { name: "DF 6x6 Inch D", image: [df_2] },
      { name: "DF 8x8 Inch D", image: [df_2] },
      { name: "DF 10x10 Inch D", image: [df_2] },
    ],  
    seo: {
      title: "Dock Fenders - Superior Protection for Marine Infrastructure | Elastomech",
      description: "Innovating Dock Fenders and a comprehensive line of rubber products, ensuring superior protection for marine infrastructure worldwide. Reliable, durable, and versatile for safe docking and mooring operations.",
      keywords: "dock fenders,boat dock fenders, rubber fenders, marine protection, berthing fenders, mooring fenders, rubber dock fenders",
     },
  },
  {url:"dock-bumpers",
    id: 2,
    title: "Dock Bumpers",
    name:"DockBumpers",
    description:
      "At Elastomech, we proudly offer a comprehensive range of high-performance Dock Bumpers, designed to safeguard your docks and vessels with unmatched durability",
    image: d_b_13x10x4,
    application: [
      "These bumpers provide essential protection, absorbing impact to prevent damage to both loading docks and vehicles during loading and unloading operations.",
      "With their versatility in size and configuration, they seamlessly adapt to different loading scenarios, ensuring effective and comprehensive coverage.",
      "Choosing our rubber dock bumpers means investing in peace of mind, knowing that your facilities are equipped with durable solutions that prioritize safety and functionality.",
    ],
    technicals: [
      "NR / SBR Blend",
      "Black",
      "73 + _3 Shore A",
      "8 MPa",
      "6 - 12 Tonnes",
    ],
    variety: [
      { name: "DB 13x10x4 Inch", image: [d_b_13x10x4] },
      { name: "DB 18x10x4 Inch.", image: [d_b_18x10x4, d_b_18x10x4_2] },
      { name: "DB 30x10x4 Inch.", image: [d_b_30x10x4, d_b_30x10x4_2] },
    ],
    seo: {
      title: "Dock Bumpers - Impact Protection for Marine Infrastructure | Elastomech",
      description: "Innovating Dock Bumpers designed to provide impact protection and extend the lifespan of marine infrastructure. Reliable, durable, and essential for secure mooring and docking operations.",
      keywords: "dock bumpers, marine bumpers, impact protection, mooring bumpers, rubber dock bumper, boat dock bumpers"
    }
  },
  {url:"wheel-chokers",
    id: 3,
    title: "Wheel Chokers",
    name:"WheelChokers",
    description:
      "Wheel chokers are practical devices designed to secure wheels, preventing unintended movement of vehicles or machinery.Crafted from durable materials",
    image: wc_8,
    application: [
      "Wheel chokers are indispensable for ensuring safety during loading, unloading, or maintenance tasks, where securing stationary positioning of vehicles or machinery is crucial.",
      "Their straightforward design allows for easy installation and removal, making them ideal for use in warehouses, construction sites, and other industrial environments.",
      "Available in different sizes and configurations to accommodate various wheel diameters and types, wheel chokers provide a versatile solution for securing equipment and preventing accidents caused by rolling or shifting.",
    ],

    technicals: [
      "NR / SBR Blend",
      "Black",
      "73 + _3 Shore A",
      "8 MPa",
      "2 - 40 Tonnes",
    ],
    variety: [
      { name: "Stopper Kerb 1 mtr", image: [kirb, kirb2] },
      { name: "Yellow Arcraft WC", image: [ac_yellow] },
      { name: "Black Arcraft WC", image: [ac_black] },
      { name: "Metal WC", image: [yellow_mwc, yellow_mwc2] },
      { name: "Black Car Stopper", image: [car, car2] },
      { name: "Yellow Car Stopper", image: [car_yellow, car_yellow2] },
      { name: "Lorry Stopper", image: [lorry, lorry2] },
      { name: "WC with Handle", image: [handle_wc, handle_wc2] },
     
    ],
    seo: {
      title: "Wheel Chokers - Secure Vehicle Parking and Safety | Elastomech",
      description: "Our Wheel Chokers provide reliable solutions for securing vehicles in place, ensuring safety and preventing unwanted movement during parking operations.",
      keywords: "wheel chokers, vehicle safety, parking chokers, rubber chokers, rubber wheel chokers"
    }
  },
  {url:"speed-breakers",
    id: 4,
    title: "Speed Breakers",
    name:"SpeedBreakers",
    description:
      "High-quality, durable speed breakers designed to enhance road safety and manage traffic effectively. Built with robust materials, our speed breakers are engineered",
    image: black_speed_breaker,
    application: [
      "Schools and Hospitals: Installed near schools, hospitals, and other sensitive areas to slow  down traffic and protect vulnerable individuals.",
      "Parking Lots: Placed in parking lots to manage the speed of vehicles and prevent  accidents.",
      "Industrial Areas: Used in factories, warehouses, and industrial zones to reduce speed and  ensure safety of workers and equipment.",
      "Pedestrian Crossings: Positioned at pedestrian crossing points to slow down vehicles,  enhancing pedestrian safety.",
    ],
    technicals: [],
    variety: [
      { name: "Speed Braker Black", image: [sb_black] },
      { name: "Speed Braker Yellow", image: [sb_yellow, sb_yellow2] },
    ],
    seo: {
      title: "Speed Breakers - Traffic Control and Safety | Elastomech",
      description: "Our Speed Breakers are designed for effective traffic control, promoting safety and reducing vehicle speed in critical zones. Durable and weather-resistant for long-term use.",
      keywords: "speed breakers, rubber speed breakers, rubber road products,road humps"
    }
  },
  {url:"hose-ramps",
    id: 5,
    title: "Hose Ramps",
    name:"HoseRamps",
    description:
      "At Elastomech, we design and manufacture high-quality hose ramps, providing durable solutions for accessibility and convenience.",
    image: Hcr_4,
    application: [
      "Essential for protecting hoses and cables from vehicular activities in warehouses, construction sites, and industrial facilities.",
      "Featuring an anti-slip surface and sturdy design, they ensure stability and prevent accidental displacement, even in high-traffic areas.",
      "Available in various sizes and configurations to accommodate different hose diameters, rubber hose ramps offer versatile and effective protection for critical equipment.",
    ],
    technicals: [
      "NR / SBR Blend",
      "Black",
      "73 + _3 Shore A",
      "8 MPa",
      "6 - 15 Tonnes",
    ],
    variety: [
      { name: "HR 3 Inch", image: [hc_3, hc_3_2] },
      { name: "HR 4 Inch", image: [hc_4_2, hc_4] },
      { name: "HR 5 Inch", image: [hc_5_2, hc_5] },
      { name: "HCR 4 Inch", image: [Hcr_4] },
      { name: "HCR 4 Inch [With Metal]", image: [Hcr_4] },
    ],
    seo: {
      title: "Hose Ramps - Protection and Safety for Hose Lines | Elastomech",
      description: "Our Hose Ramps are designed to protect hoses from damage, ensuring safety and efficiency in industrial and construction environments. Durable and easy to deploy.",
      keywords: "hose ramps, hose protection, industrial hose ramps, rubber hose ramps, hose safety, hose line protection,hose ramp with metal insert"
    }
  },
  {url:"cable-protectors",
    id: 6,
    title: "Cable Protectors",
    name:"CableProtectors",
    description:
      "Durable and reliable cable protectors designed to safeguard wires and prevent tripping hazards, ensuring safety in high-traffic areas.",
    image: core_cable_protector,
    application: [
      "Rubber cable protectors are essential for maintaining the integrity of cables in various settings, including event venues, construction sites, warehouses, and outdoor areas.",
      "Their simple yet effective design features channels or slots to securely hold multiple cables in place, preventing tangling and reducing the risk of tripping hazards.",
      "Available in a range of sizes and configurations to accommodate different cable diameters and quantities, rubber cable protectors offer versatile solutions for ensuring the safety and longevity of electrical and data communication systems.",
    ],
    technicals: [
      "NR / SBR Blend,EPDM Rubber",
      "Black",
      "68 + _3 Shore A",
      "8 MPa",
      "1.5 Tonnes",
    ],
    variety: [
      { name: "Single Core Cp - 1 Inch Cable", image: [cp_1] },
      { name: "Double Core Cp - 30mm Cable", image: [cp_2] },
    ],
    seo: {
      title: "Cable Protectors - Safe and Durable Cable Management | Elastomech",
      description: "Protect and manage cables effectively with our Cable Protectors, designed to prevent tripping hazards and damage to cables in high-traffic areas. Reliable and long-lasting.",
      keywords: "cable protectors, cable safety, rubber cable protectors, cable management, cable protection, industrial cable safety, traffic safety"
    }
  },
  {url:"rubber-stoppers",
    id: 7,
    title: "Rubber Buffers/Stoppers",
    name:"RubberStoppers",
    description:
      "Our rubber buffers are engineered for resilience in demanding industrial environments. Crafted from premium rubber compounds, they embody durability and reliability, ensuring consistent performance over time.",
    image: core_cable_protector,
    application: [
      "These buffers serve as essential shock absorbers, effectively dampening vibrations and minimizing impact to protect machinery and equipment during operation.",
      "With a range of sizes and configurations available, they offer versatile solutions tailored to specific machinery requirements, guaranteeing optimal fit and functionality.",
      "By integrating our rubber buffers, clients enhance the efficiency and longevity of their operations, mitigating potential damage and reducing maintenance costs for sustained productivity.",
    ],
    technicals: [
      "NR / SBR Blend",
      "Black",
      "60 to 75 +_ 3 Shore A",
      "6 to 8 MPa",
      "2 - 40 Tonnes",
    ],
    variety: [
      { name: "Round RB 3 Inch", image: [door_bush] },
      { name: "Rectangular RB 5 Inch", image: [Rb_All] },
      { name: "Rectangular RB 6x2x2 Inch", image: [Rb_All] },
      { name: "Rectangular RB 8x2x2 Inch", image: [Rb_All] },
      { name: "Rectangular RB 10x2x2 Inch", image: [Rb_All] },
      { name: "Rectangular RB 12x2x2 Inch", image: [Rb_All] },
      { name: "RB 8 Inch D", image: [Rb8] },
      { name: "Door Bush", image: [door_bush, door_bush2] },
    ],
    seo: {
      title: "Rubber Stoppers - Secure and Versatile Solutions | Elastomech",
      description: "Our Rubber Stoppers are perfect for sealing containers, protecting equipment, and preventing damage in various industries. Durable, versatile, and easy to use.",
      keywords: "rubber stoppers, container sealing, Rubber Stoppers Manufacturer,Supplier,Exporter, industrial stoppers, rubber seals, versatile stoppers, sealing solutions"
    }
  },
  {url:"tipper-pads",
    id: 8,
    title: "Tipper-Pads",
    name:"TipperPads",
    description:
      "Our rubber to metal bonded parts are meticulously designed and manufactured to provide superior performance and longevity in the most demanding industrial environments. Combining the flexibility and resilience of rubber with the strength and durability of metal, these components are essential for reducing vibration, absorbing shock, and ensuring smooth operation in various machinery and equipment. Our product range includes high-quality tipper pads, extrusion pads, and other custom rubber to metal bonded solutions tailored to meet your specific needs.",
    image: core_cable_protector,
    application: [
      "Construction Vehicles: Primarily used in tipper trucks or dump trucks in construction,  where the truck body frequently tilts to unload materials.",
      "Mining Trucks: Used in large mining trucks to protect the truck’s frame during heavy  load dumping operations.",
      "Agricultural Vehicles: Installed in agricultural trucks to absorb shocks and protect the  chassis during tipping of harvested materials.",
    ],
    technicals: ["Natural or Synthetic Rubber", "Black", "", "", ""],
    variety: [{ name: "Tipper Pads", image: [tipper] }],
    seo: {
      title: "Tipper Pads - Effective Load Distribution and Protection | Elastomech",
      description: "Tipper Pads provide optimal load distribution and protection for vehicles and equipment during tipping operations, improving efficiency and safety.",
      keywords: "tipper pads, load distribution pads, vehicle protection, tipping pads, rubber tipper pads, industrial load pads, equipment protection"
    }
  },
  {url:"corner-guards",
    id: 9,
    title: "Wall/Corner Guards",
    name:"CornerGuards",
    description:
      "Rubber wall and corner guards are resilient protective solutions designed to shield walls and corners from damage in various environments. Crafted from durable rubber materials, they offer robust defense against impacts and abrasions, ensuring long-lasting protection for walls and corners.",
    image: core_cable_protector,
    application: [
      "Essential for safeguarding walls and corners in high-traffic areas such as corridors, loading docks, parking garages, and industrial facilities.",
      "With their flexible and impact-absorbing properties, they effectively minimize damage from collisions with carts, vehicles, and other objects.",
      "Available in a range of sizes, colors, and profiles to suit different wall types and aesthetic preferences, rubber wall and corner guards provide versatile and discreet protection while maintaining the appearance of the space.",
    ],
    technicals: ["NR / SBR Blend", "Black", "73 +_ 3 Shore A", "8 MPa", " "],
    variety: [
      { name: "", image: [wg,wg2] },
    ],
    seo: {
      title: "Corner Guards - Protection and Safety for Edges | Elastomech",
      description: "Our Corner Guards provide superior protection for walls and furniture edges, preventing damage and reducing maintenance costs. Ideal for industrial, commercial, and residential use.",
      keywords: "corner guards, edge protection, wall corner protectors, rubber corner guards, industrial corner guards, furniture protection, wall protection"
    }
  },

];
